import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useDidUpdateEffect from '../../../common/hooks/useDidUpdateEffect'
import { Element } from '../../../common/html/element'
import { debounce } from '../../../helpers/common'
import { Input } from '../../common/html/input'
import style from '../index.module.scss'
import { changeFilter, selectFilterTableFollowingList } from '../store/slice'

export const Search = () => {
  const dispatch = useDispatch()

  const text = useSelector(selectFilterTableFollowingList('term'))

  const [inputValue, setInputValue] = useState(text)

  const handleChangeText = useCallback(
    debounce((value) => {
      dispatch(
        changeFilter({
          term: value.trim(),
          page: 1,
        }),
      )
    }, 700),
    [],
  )

  //UseEffect
  useDidUpdateEffect(() => {
    handleChangeText(inputValue)
  }, [inputValue])

  return (
    <>
      <div className={['dFlex', style.search].join(' ')}>
        <Element className={['dFlex', style.contentLeft].join(' ')}>
          <Input
            containerStyle={{
              minWidth: 470,
              height: 28,
            }}
            placeHolder="library.detailsPortfolios.SEARCH_COMPANY_TEXT_CODE"
            type="text"
            onChange={setInputValue}
            value={inputValue}
            isSearch
          />
        </Element>
      </div>
    </>
  )
}
